import { timelineItems } from "@/mocks/homeContent";

const tagTone: Record<string, string> = {
  线路: "bg-primary-100 text-primary-700",
  审核: "bg-accent-100 text-accent-800",
  验证: "bg-secondary-100 text-secondary-800",
  好用: "bg-accent-100 text-accent-800",
  广告: "bg-primary-100 text-primary-700",
  靠谱: "bg-secondary-100 text-secondary-800",
};

export default function Timeline() {
  return (
    <section id="timeline" className="w-full border-b border-background-200 bg-background-100">
      <div className="w-full px-4 py-12 md:px-8 md:py-20">
        <div className="mx-auto max-w-3xl">
          <p className="font-label text-[11px] uppercase tracking-[0.34em] text-primary-600">Timeline · 快讯流</p>
          <h2 className="mt-4 font-heading text-3xl font-bold text-foreground-950 md:text-4xl">
            最近都发生了什么
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600">
            维护、提速、改版、收敛——按时间倒序记录，每一条都能对上你遇到过的那个瞬间。
          </p>

          <ol className="relative mt-12 border-l border-background-300">
            {timelineItems.map((it) => (
              <li key={`${it.date}-${it.title}`} className="relative pb-10 pl-6 last:pb-0 md:pl-8">
                <span className="absolute -left-[5px] top-1.5 h-2.5 w-2.5 rounded-full bg-accent-500 ring-4 ring-background-100" />
                <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
                  <span className="font-heading text-lg font-bold text-foreground-950">{it.date}</span>
                  <span className="text-[11px] tracking-widest text-foreground-500">{it.time}</span>
                  <span
                    className={`rounded-full px-2.5 py-0.5 text-[11px] font-medium ${
                      tagTone[it.tag] ?? "bg-secondary-100 text-secondary-800"
                    }`}
                  >
                    {it.tag}
                  </span>
                </div>
                <h3 className="mt-2 font-heading text-base font-semibold text-foreground-900 md:text-lg">
                  {it.title}
                </h3>
                <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-600">{it.desc}</p>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}